import moment from "moment";
import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function getListEquipo(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            API_BASE_URL + "/equipo/list-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].fechaadquisicion = moment.utc(data[i].fechaadquisicion).format("YYYY/MM/DD");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.idequipo,
                        label: item.idequipo,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("getListEquipo err");
        console.log(err);
        return [];
    }
}

export async function createEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/equipo/create-equipo",
            API_BASE_URL + "/equipo/create-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("createEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/equipo/disable-equipo",
            API_BASE_URL + "/equipo/disable-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/equipo/enable-equipo",
            API_BASE_URL + "/equipo/enable-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enableEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function updateEquipo(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/equipo/update-equipo",
            API_BASE_URL + "/equipo/update-equipo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("updateEquipo err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function getListEquipoCombo(obj) {
    try {
        let data = [];
        const { code, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/equipo/list-equipo-combo",
            API_BASE_URL + "/equipo/list-equipo-combo",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
        }
        return data;
    } catch (err) {
        console.log("getListEquipoCombo err");
        console.log(err);
        return [];
    }
}